import { useEffect } from "react"
import { Outlet } from "react-router-dom"

import { useSplashScreen } from "@/components/SplashScreen/useSplashScreen"

export const PublicLayout = () => {
  const { hideSplash } = useSplashScreen()

  useEffect(() => {
    hideSplash()
  }, [hideSplash])

  return <Outlet />
}
